import ProductCardsPresenter from "../../product-cards/presenter/product-cards.js";
import ProductCardPresenter from "./product-card.js";

export default class ModalRelatedProductCards extends ProductCardsPresenter {
  constructor(listElement) {
    super(listElement);

    this._ProductItemPresenter = ProductCardPresenter;
  }
}
